import DOMPurify from "dompurify";

const SANITIZE_OPTIONS = {
  ADD_TAGS: ["span", "a", "strong"],
  ADD_ATTR: ["href", "target", "rel"],
};

export function safeHtml(raw) {
  return DOMPurify.sanitize(raw, SANITIZE_OPTIONS);
}
